import type { PaletteColor } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useCallback } from 'react';
import { isKeyOfObject } from '@/util/object';
import type { AlarmSeverity } from './api.types';

export function useSeverityColor() {
  const theme = useTheme();

  return useCallback(
    (severity: AlarmSeverity): PaletteColor => {
      const severityName = severity.toLowerCase();

      if (isKeyOfObject(severityName, theme.palette.severity)) {
        return theme.palette.severity[severityName];
      }

      return theme.palette.severity.fallback;
    },
    [theme]
  );
}
